import React from "react";

const SvgIcon = ({ children }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="mypage-sidebar__icon"
    aria-hidden
  >
    {children}
  </svg>
);

export const SidebarCoursesIcon = () => (
  <SvgIcon>
    <path
      d="M11.6663 9.1665H6.66634M8.33301 12.4998H6.66634M13.333 5.83317H6.66634M16.6663 5.6665V14.3332C16.6663 15.7333 16.6663 16.4334 16.3939 16.9681C16.1542 17.4386 15.7717 17.821 15.3013 18.0607C14.7665 18.3332 14.0665 18.3332 12.6663 18.3332H7.33301C5.93288 18.3332 5.23281 18.3332 4.69803 18.0607C4.22763 17.821 3.84517 17.4386 3.60549 16.9681C3.33301 16.4334 3.33301 15.7333 3.33301 14.3332V5.6665C3.33301 4.26637 3.33301 3.56631 3.60549 3.03153C3.84517 2.56112 4.22763 2.17867 4.69803 1.93899C5.23281 1.6665 5.93288 1.6665 7.33301 1.6665H12.6663C14.0665 1.6665 14.7665 1.6665 15.3013 1.93899C15.7717 2.17867 16.1542 2.56112 16.3939 3.03153C16.6663 3.56631 16.6663 4.26637 16.6663 5.6665Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const SidebarCertificateIcon = () => (
  <SvgIcon>
    <path
      d="M5.41667 16.6665H4.16667C3.24619 16.6665 2.5 15.9203 2.5 14.9998V3.33317C2.5 2.4127 3.24619 1.6665 4.16667 1.6665H15.8333C16.7538 1.6665 17.5 2.4127 17.5 3.33317V14.9998C17.5 15.9203 16.7538 16.6665 15.8333 16.6665H14.5833M10 15.8332C11.3807 15.8332 12.5 14.7139 12.5 13.3332C12.5 11.9525 11.3807 10.8332 10 10.8332C8.61929 10.8332 7.5 11.9525 7.5 13.3332C7.5 14.7139 8.61929 15.8332 10 15.8332ZM10 15.8332L10.0179 15.833L7.35723 18.4936L5.0002 16.1366L7.51638 13.6204M10 15.8332L12.6607 18.4936L15.0177 16.1366L12.5015 13.6204M7.5 4.99984H12.5M5.83333 7.9165H14.1667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const SidebarReceiptIcon = () => (
  <SvgIcon>
    <path
      d="M16.6663 17.5V6.5C16.6663 5.09987 16.6663 4.3998 16.3939 3.86502C16.1542 3.39462 15.7717 3.01217 15.3013 2.77248C14.7665 2.5 14.0665 2.5 12.6663 2.5H7.33301C5.93288 2.5 5.23281 2.5 4.69803 2.77248C4.22763 3.01217 3.84517 3.39462 3.60549 3.86502C3.33301 4.3998 3.33301 5.09987 3.33301 6.5V17.5L5.62467 15.8333L7.70801 17.5L9.99967 15.8333L12.2913 17.5L14.3747 15.8333L16.6663 17.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.08301 8.74919H7.09134M9.99967 8.74919H10.008M12.9163 8.74919H12.9247"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </SvgIcon>
);

export const SidebarLogoutIcon = () => (
  <SvgIcon>
    <path
      d="M7.5 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H7.5M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const SidebarInquiryIcon = () => (
  <SvgIcon>
    <path
      d="M8.33366 12.4998L5.77095 15.0946C5.41348 15.4565 5.23475 15.6375 5.08112 15.6502C4.94784 15.6613 4.81734 15.6077 4.73029 15.5062C4.62996 15.3892 4.62996 15.1348 4.62996 14.6261V13.3262C4.62996 12.8698 4.25622 12.5396 3.80466 12.4734C2.71178 12.3134 1.85347 11.4551 1.69339 10.3622C1.66699 10.182 1.66699 9.96693 1.66699 9.53687V5.6665C1.66699 4.26637 1.66699 3.56631 1.93948 3.03153C2.17916 2.56112 2.56161 2.17867 3.03202 1.93899C3.5668 1.6665 4.26686 1.6665 5.66699 1.6665H11.8337C13.2338 1.6665 13.9339 1.6665 14.4686 1.93899C14.939 2.17867 15.3215 2.56112 15.5612 3.03153C15.8337 3.56631 15.8337 4.26637 15.8337 5.6665V9.1665M15.8337 18.3332L14.02 17.0722C13.765 16.895 13.6376 16.8064 13.4988 16.7435C13.3757 16.6878 13.2462 16.6472 13.1133 16.6227C12.9635 16.5951 12.8083 16.5951 12.4978 16.5951H11.0003C10.0669 16.5951 9.60019 16.5951 9.24367 16.4134C8.93007 16.2536 8.6751 15.9987 8.51531 15.6851C8.33366 15.3285 8.33366 14.8618 8.33366 13.9284V11.8332C8.33366 10.8997 8.33366 10.433 8.51531 10.0765C8.6751 9.76292 8.93007 9.50795 9.24367 9.34816C9.60019 9.1665 10.0669 9.1665 11.0003 9.1665H15.667C16.6004 9.1665 17.0671 9.1665 17.4236 9.34816C17.7372 9.50795 17.9922 9.76292 18.152 10.0765C18.3337 10.433 18.3337 10.8997 18.3337 11.8332V14.0951C18.3337 14.8716 18.3337 15.2599 18.2068 15.5662C18.0376 15.9746 17.7132 16.2991 17.3048 16.4682C16.9985 16.5951 16.6102 16.5951 15.8337 16.5951V18.3332Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
